<template>
  <div class="com-score">
    <div class="title">
      {{ roundGroups.length == 1 ? '半场比分' : '全场比分' }}
    </div>
    <div class="team-info">
      <div class="left team">
        <div class="icon image">
          <img v-hb-img.src="teamA.team_icon" />
        </div>
        <div class="name hel-font">{{ teamA.name }}</div>
        <div class="type center" v-if="cptType == 'half_score'">
          <div class="inner">攻</div>
        </div>
      </div>
      <div class="score">
        <div class="left box center ali-font" :class="getScoreClass('a')">
          {{ teamA.score }}
        </div>
        <div class="seq">:</div>
        <div class="right box center ali-font" :class="getScoreClass('b')">
          {{ teamB.score }}
        </div>
      </div>
      <div class="right team">
        <div class="type center" v-if="cptType == 'half_score'">
          <div class="inner">守</div>
        </div>
        <div class="name hel-font">{{ teamB.name }}</div>
        <div class="icon image">
          <img v-hb-img.src="teamB.team_icon" />
        </div>
      </div>
    </div>
    <div class="groups">
      <div
        class="panel"
        v-for="(group, groupIndex) in roundGroups"
        :key="groupIndex"
      >
        <div class="header">
          <div class="row-1">A/B</div>
          <div class="row-2">经济</div>
          <div class="row-3">{{ teamA.name }}</div>
          <div class="row-4">{{ teamB.name }}</div>
        </div>
        <div class="round-list">
          <div
            class="round"
            v-for="(round, roundIndex) in group"
            :key="roundIndex"
          >
            <div class="row-1 hel-font">
              {{ groupIndex * 12 + roundIndex + 1 }}
            </div>
            <div class="row-2">
              <div class="progress" v-if="round.team_a">
                <div
                  class="inner left"
                  :style="{ height: round.team_a.percent }"
                ></div>
              </div>
              <div class="progress" v-if="round.team_b">
                <div
                  class="inner right"
                  :style="{ height: round.team_b.percent }"
                ></div>
              </div>
            </div>
            <div class="row-3">
              <div
                class="icon image"
                v-if="round.team_a && round.team_a.result_icon"
              >
                <img v-hb-img.src="round.team_a.result_icon" />
              </div>
            </div>
            <div class="row-4">
              <div
                class="icon image"
                v-if="round.team_b && round.team_b.result_icon"
              >
                <img v-hb-img.src="round.team_b.result_icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataInfo: {
      type: Object,
      default: () => ({}),
    },
    matchData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    cptType() {
      return this.dataInfo.card_params.type == 'half_score'
        ? 'half_score'
        : 'score';
    },
    teamA() {
      return this.matchData?.[this.cptType]?.team_a || {};
    },
    teamB() {
      return this.matchData?.[this.cptType]?.team_b || {};
    },
    roundList() {
      return this.matchData?.[this.cptType]?.round_list || [];
    },
    roundGroups() {
      return [
        this.roundList.slice(0, 12),
        this.roundList.slice(12, 24),
        this.roundList.slice(24),
      ]
        .filter((item) => item.length)
        .map((item) => {
          return Array.from({ length: 12 }, (_, index) => {
            return item[index] || {};
          });
        });
    },
  },
  methods: {
    getScoreClass(type) {
      const result =
        type == 'a'
          ? this.teamA.score >= this.teamB.score
          : this.teamB.score >= this.teamA.score;
      return result ? 'dark' : 'gray';
    },
  },
};
</script>

<style lang="less" scoped>
.com-score {
  padding: 10px;
  .title {
    font-size: 12px;
    line-height: 17px;
    font-weight: 500;
    color: #14191e;
  }
  .team-info {
    height: 50px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    justify-content: space-between;
    position: relative;
    .team {
      display: flex;
      align-items: center;
      &.left {
        color: rgba(74, 153, 138, 1);
        .type {
          background: rgba(74, 153, 138, 1);
        }
      }
      &.right {
        color: rgba(184, 80, 89, 1);
        .type {
          background: linear-gradient(
            to right,
            rgba(255, 103, 113, 1),
            rgba(245, 62, 89, 1)
          );
        }
      }
      .icon {
        width: 24px;
        height: 24px;
        img {
          border-radius: 3px;
          object-fit: scale-down;
        }
      }
      .name {
        margin: 0 5px;
        font-size: 12px;
        font-weight: 500;
      }
      .type {
        width: 14px;
        height: 14px;
        border-radius: 2px;
        .inner {
          font-size: 16px;
          color: #ffffff;
          transform: scale(0.5);
        }
      }
    }
    .score {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: flex;
      align-items: center;
      .box {
        height: 34px;
        min-width: 26px;
        padding: 0 6px;
        background: rgba(218, 221, 224, 0.29);
        border-radius: 2px;
        &.dark {
          color: rgba(20, 25, 30, 1);
        }
        &.gray {
          color: rgba(200, 205, 210, 1);
        }
      }
      .seq {
        color: rgba(200, 205, 210, 1);
        font-size: 24px;
        margin: 0 7px;
      }
    }
  }
  .groups {
    margin-top: 10px;
    .panel {
      display: flex;
      border-radius: 5px;
      overflow: hidden;
      & + .panel {
        margin-top: 4px;
      }
      .header,
      .round {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 8px 0;
        .row-1 {
          height: 16px;
        }
        .row-2 {
          height: 26px;
          margin-top: 12px;
        }
        .row-3,
        .row-4 {
          height: 16px;
          margin-top: 12px;
        }
        [class^='row-'] {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .header {
        width: 43px;
        background: rgba(243, 244, 245, 1);
        font-size: 12px;
        font-weight: 500;
        .row-1 {
          font-size: 11px;
          color: rgba(140, 145, 150, 1);
          font-weight: normal;
        }
        .row-2 {
          color: rgba(20, 25, 30, 1);
        }
        .row-3 {
          color: rgba(74, 153, 138, 1);
        }
        .row-4 {
          color: rgba(180, 69, 78, 1);
        }
      }
      .round-list {
        width: 0;
        flex: 1;
        display: flex;
        .round {
          width: 0;
          flex: 1;
          &:nth-child(2n) {
            background: rgba(243, 244, 245, 1);
          }
          .row-1 {
            font-size: 10px;
            color: rgba(20, 25, 30, 1);
          }
          .row-2 {
            display: flex;
            .progress {
              width: 6px;
              height: 26px;
              border-radius: 1px;
              overflow: hidden;
              background: rgba(218, 221, 224, 1);
              display: flex;
              position: relative;
              & + .progress {
                margin-left: 2px;
              }
              .inner {
                width: 100%;
                position: absolute;
                left: 0;
                bottom: 0;
                border-radius: 1px;
                &.left {
                  background: rgba(22, 186, 157, 1);
                }
                &.right {
                  background: linear-gradient(
                    to right,
                    rgba(251, 69, 113, 1),
                    rgba(201, 54, 71, 1)
                  );
                }
              }
            }
          }
          .row-3,
          .row-4 {
            .icon {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
  }
}
</style>
